"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withErrorManager = exports.ErrorManager = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var hoistNonReactStatics = require("hoist-non-react-statics");
var pinpo_ui_kit_1 = require("pinpo-ui-kit");
var react_1 = require("@iconify/react");
var alert_1 = __importDefault(require("@iconify/icons-mdi/alert"));
var services_1 = require("../services");
var ErrorManager = /** @class */ (function (_super) {
    __extends(ErrorManager, _super);
    function ErrorManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: null
        };
        // Default renderError implementation
        _this.defaultRenderError = function () {
            var labelForError = _this.props.labelForError;
            return (React.createElement("div", { className: "optional-component-error" },
                React.createElement(react_1.Icon, { icon: alert_1.default, color: pinpo_ui_kit_1.Colors.failure, style: { fontSize: "2.4rem" } }),
                React.createElement("div", null,
                    "Le composant",
                    " ",
                    React.createElement("span", { className: "tree-label" }, labelForError),
                    labelForError && " ",
                    "n'a pas pu \u00EAtre affich\u00E9 en raison d'une erreur.")));
        };
        _this.renderError = function (error) {
            var renderError = _this.props.renderError;
            var renderer = renderError || _this.defaultRenderError;
            return renderer(error);
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
    ErrorManager.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
    ErrorManager.prototype.componentDidCatch = function (error, info) {
        var reportError = this.props.reportError;
        // Report (default to Sentry)
        var reporter = reportError || services_1.Sentry.report;
        reporter(error, info);
    };
    ErrorManager.prototype.render = function () {
        var error = this.state.error;
        var children = this.props.children;
        return error
            ? this.renderError(error)
            : children;
    };
    ErrorManager.propTypes = {
        renderError: PropTypes.func,
        reportError: PropTypes.func,
        labelForError: PropTypes.string,
        children: PropTypes.node
    };
    return ErrorManager;
}(React.Component));
exports.ErrorManager = ErrorManager;
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'MyComponent' implicitly has an 'any' ty... Remove this comment to see the full error message
function withErrorManager(MyComponent) {
    // @ts-expect-error ts-migrate(7031) FIXME: Binding element '_pinpoWebFrameworkForwardedRef' i... Remove this comment to see the full error message
    function WithErrorManager(_a) {
        var _pinpoWebFrameworkForwardedRef = _a._pinpoWebFrameworkForwardedRef, props = __rest(_a, ["_pinpoWebFrameworkForwardedRef"]);
        return (React.createElement(ErrorManager, { renderError: MyComponent.renderError, reportError: MyComponent.reportError, labelForError: MyComponent.labelForError },
            React.createElement(MyComponent, __assign({ ref: _pinpoWebFrameworkForwardedRef }, props))));
    }
    WithErrorManager.displayName = "WithErrorManager(" + (MyComponent.displayName || "UnknownComponent") + ")";
    // Return HOC with ref, static functions, static attributes and props
    return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithErrorManager, __assign({}, props, { _pinpoWebFrameworkForwardedRef: ref }))); }), MyComponent);
}
exports.withErrorManager = withErrorManager;
//# sourceMappingURL=ErrorManager.js.map